import React from 'react';

import "./Spinner.css"

interface SpinnerProps {
}



const Spinner: React.FC<SpinnerProps> = (props) => {
    return (
        <div className='spinner'>
            <span className='loader' />
        </div>
    );
}

export default Spinner;
